import { loadable } from '@shared/core/loadableFromNamedExport';

// Autocomplete pulls in Command + PopoverV2 synchronously, and the name-affix
// fields are feature-flagged — lazy keeps that machinery out of the form's
// initial chunk when the flag is off.
export const LazyNameAffixField = loadable(() => import(/* webpackChunkName: "content/contactCollector/name-affix-field" */ './NameAffixField'), 'NameAffixField');
